import {Component, OnInit} from '@angular/core';
import {DropletService} from '../../Services/Droplet.service';
import {TimeSeriesDashboard, TimeSeriesDashboardService} from '../../Services/time-series-dashboard.service';

interface CounterContentItem {
  number: number;
  title: string;
}


@Component({
  selector: 'app-portal-home',
  templateUrl: './portal-home.component.html',
  styleUrls: ['./portal-home.component.scss']
})
export class PortalHomeComponent implements OnInit {


  topicsItems: any;
  counterContent: CounterContentItem[] = [
    // {
    //   number: 10333,
    //   title: 'Datasets'
    // }
  ];
  monitoringGridItems: any;
  informationGridItems: any;

  countTimeSeries: number;
  countParameters: number;
  countMonitoringStations: number;

  constructor(
    public service: DropletService,
    private timeSeriesDashboardService: TimeSeriesDashboardService
  ) {
  }

  ngOnInit() {


    // topics content
    this.service.getTopicsContent().subscribe(response => {
        this.topicsItems = response;
      },
      err => console.log(err),
      () => this.topicsItems
    );

    this.service.getMonitoringGridContent().subscribe(response => {
        this.monitoringGridItems = response;
      },
      err => console.log(err),
      () => this.monitoringGridItems
    );

    this.service.getInformationGridContent().subscribe(response => {
        this.informationGridItems = response;
      },
      err => console.log(err),
      () => this.informationGridItems
    );


    this.timeSeriesDashboardService.fetchDashboardData()
      .subscribe((tsDashboard: TimeSeriesDashboard) => {

        this.counterContent.push({
          number: tsDashboard.monitoringStations.length,
          title: 'Monitoring stations'
        });

        this.counterContent.push({
          number: tsDashboard.countTimeSeries,
          title: 'Time-series'
        });

        // this.counterContent.push({
        //   number: 110,
        //   title: 'Years of data available'
        // });

      });

  }

}
